import { useRef, useEffect } from 'react'

import ArtisanLogo from './artisan_logo.json'

const ArtisanLogoLottie = () => {
  const lottieRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const loadLottie = async () => {
      if (!lottieRef.current) return
      const lottie = (await import('lottie-web')).default

      lottie.loadAnimation({
        container: lottieRef.current,
        renderer: 'svg',
        autoplay: true,
        loop: false,
        animationData: ArtisanLogo,
      })
    }
    loadLottie()
  }, [])

  return <div ref={lottieRef} />
}

export default ArtisanLogoLottie
